import {Suspense, lazy} from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'
import {FallbackView} from '../../_CarWash/partials'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {MenuTestPage} from '../pages/MenuTestPage'

export function PrivateRoutes() {
  const BuilderPageWrapper = lazy(() => import('../pages/layout-builder/BuilderPageWrapper'))
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  // ============================ Master ========================
  const CountryMasterPage = lazy(
    () => import('../modules/master-page/country-master-page/CountryMasterPage')
  )
  // ================================================================
  const StateMasterPage = lazy(
    () => import('../modules/master-page/state-master-page/StateMasterPage')
  )
  // ================================================================
  const CityMasterPageMasterPage = lazy(
    () => import('../modules/master-page/district-master-page/CityMasterPageMasterPage')
  )
  // ================================================================
  const TalukaMasterPage = lazy(
    () => import('../modules/master-page/taluka-master-page/TalukaMasterPage')
  )
  // ================================================================
  const NationalityMasterPage = lazy(
    () => import('../modules/master-page/nationality-master-page/NationalityMasterPage')
  )
  // ================================================================
  const EducationCategoryPage = lazy(
    () => import('../modules/master-page/education-category-master-page/EducationCategoryPage')
  )
  // ================================================================
  const EducationDepartmentPage = lazy(
    () => import('../modules/master-page/education-department-master-page/EducationDepartmentPage')
  )
  // ================================================================
  const DocumentTypePage = lazy(
    () => import('../modules/master-page/document-type-page/DocumentTypePage')
  )
  // ================================================================
  const KycDocumentMasterPage = lazy(
    () => import('../modules/master-page/kyc-document-page/KycDocumentMasterPage')
  )
  const UnitMasterPage = lazy(
    () => import('../modules/master-page/unit-master-page/UnitMasterPage')
  )
  // ================================= Organization ==========================
  const EmployeeMasterPage = lazy(
    () => import('../modules/organization-page/employee-master-page/EmployeeMasterPage')
  )
  // ================================================================
  const UserMasterPage = lazy(
    () => import('../modules/organization-page/user-master-page/UserMasterPage')
  )
  // ================================================================
  const CustomerMasterPage = lazy(
    () => import('../modules/organization-page/customer-master-page/CustomerMasterPage')
  )
  // ==================================================================
  const FieldExecutiveMasterPage = lazy(
    () =>
      import('../modules/organization-page/field-executive-master-page/FieldExecutiveMasterPage')
  )

  // ================================================================
  const DepartmentMasterPage = lazy(
    () => import('../modules/master-page/department-master-page/DepartmentMasterPage')
  )
  // ================================================================
  const DesignationMasterPage = lazy(
    () => import('../modules/master-page/designation-master-page/DesignationMasterPage')
  )
  // ================================================================
  const BranchMasterPage = lazy(
    () => import('../modules/master-page/branch-master-page/BranchMasterPage')
  )
  // ================================================================
  const OrganizationBankMasterPage = lazy(
    () => import('../modules/master-page/organization-bank-master-page/OrganizationBankMasterPage')
  )
  // ================================================================
  const ChangePasswordPage = lazy(() => import('../modules/change-password/ChangePasswordPage'))

  // ================================================================
  const AreaPinCodeMasterPage = lazy(
    () => import('../modules/master-page/area-pincode-master-page/AreaPinCodeMasterPage')
  )

  // ================================================================
  const SocietyMasterPage = lazy(
    () => import('../modules/master-page/society-master-page/SocietyMasterPage')
  )
  // ========================================================================================
  const ServiceCategoryMasterPage = lazy(
    () => import('../modules/master-page/service-category-master-page/ServiceCategoryMasterPage')
  )
  // ========================================================================================
  const ServiceSubCategoryMasterPage = lazy(
    () =>
      import('../modules/master-page/service-subcategory-master-page/ServiceSubCategoryMasterPage')
  )
  const VehicleMakeMasterPage = lazy(
    () =>
      import('../modules/vehicle-manage-master-page/vehicle-make-master-page/VehicleMakeMasterPage')
  )
  const VehicleModelMasterPage = lazy(
    () =>
      import(
        '../modules/vehicle-manage-master-page/vehicle-model-master-page/VehicleModelMasterPage'
      )
  )
  const VehicleTypeMasterPage = lazy(
    () =>
      import('../modules/vehicle-manage-master-page/vehicle-type-master-page/VehicleTypeMasterPage')
  )
  const VehicleMasterPage = lazy(
    () => import('../modules/vehicle-manage-master-page/vehicle-master-page/VehicleMasterPage')
  )

  // ---------------------------------- Service Manage ----------------------------
  const ServicePlanMasterPage = lazy(
    () => import('../modules/service-manage-master-page/service-plan/ServicePlanMasterPage')
  )

  const ServiceMasterPage = lazy(
    () => import('../modules/service-manage-master-page/service/ServiceMasterPage')
  )

  const ServiceTypeMasterPage = lazy(
    () => import('../modules/service-manage-master-page/service-type/ServiceTypeMasterPage')
  )

  const ServiceScheduleMasterPage = lazy(
    () => import('../modules/service-manage-master-page/service-schedule/ServiceScheduleMasterPage')
  )

  // ========================================================================================
  const ItemCategoryMaterPage = lazy(
    () => import('../modules/product-manage/item-category-master-page/ItemCategoryMaterPage')
  )

  // ========================================================================================
  const ItemMaterPage = lazy(
    () => import('../modules/product-manage/item-master-page/ItemMasterPage')
  )
  const VenderMasterPage = lazy(() => import('../modules/purchase-manage/vendor/VenderMasterPage'))
  const PurchaseMasterPage = lazy(
    () => import('../modules/purchase-manage/purhase/PurchaseMasterPage')
  )

  const InventoryMasterPage = lazy(
    () => import('../modules/purchase-manage/inventory/InventoryMasterPage')
  )

  const WithoutPOInventoryMasterPage = lazy(
    () => import('../modules/purchase-manage/inventory/WithoutPOInventoryMasterPage')
  )

  const PurchaseInvoiceMasterPage = lazy(
    () => import('../modules/purchase-manage/purchase-invoice/PurchaseInvoiceMasterPage')
  )
  const CurrentStockMasterPage = lazy(
    () => import('../modules/purchase-manage/current-stock/CurrentStockMasterPage')
  )
  const BranchToBranchTransferMasterPage = lazy(
    () =>
      import(
        '../modules/purchase-manage/branch-to-branch-transfer/BranchToBranchTransferMasterPage'
      )
  )

  // ====================================driver tip====================================================
  const DriverTipMaterPage = lazy(
    () => import('../modules/master-page/driver-tip-master-page/DriverTipMasterPage')
  )
  // ========================================================================================
  const PickupDropPointMasterPage = lazy(
    () => import('../modules/master-page/pickup-drop-point-master-page/PickupDropPointMasterPage')
  )

  // ============================================================================
  const BannerImageMasterPage = lazy(
    () => import('../modules/master-page/banner-image-master-page/BannerImageMasterPage')
  )
  // ============================================================================
  const HomeVideoMasterPage = lazy(
    () => import('../modules/master-page/home-video-master-page/HomeVideoMasterPage')
  )
  // ============================================================================
  const ConfigurationMasterPage = lazy(
    () => import('../modules/configuration-master-page/ConfigurationMasterPage')
  )
  const OfferMasterPage = lazy(() => import('../modules/offer-master-page/OfferMasterPage'))
  const RechargeOfferMasterPage = lazy(
    () => import('../modules/recharge-offer/RechargeOfferMasterPage')
  )
  const WalletRechargeHistoryMasterPage = lazy(
    () => import('../modules/wallet-recharge-history/WalletRechargeHistoryMasterPage')
  )

  // ===================================orders=========================================
  const OpenOrderMasterPage = lazy(() => import('../modules/orders/open-order/OpenOrderMasterPage'))
  const FeedBackMasterPage = lazy(() => import('../modules/orders/feed-back/FeedBackMasterPage'))
  const CloseOrderMasterPage = lazy(
    () => import('../modules/orders/close-order/CloseOrderMasterPage')
  )
  const MismatchOrderMasterPage = lazy(
    () => import('../modules/orders/mismatch-order/MismatchOrderMasterPage')
  )
  const TipManageMasterPage = lazy(() => import('../modules/orders/tip-manage/TipManageMasterPage'))
  const ReportsMasterPage = lazy(() => import('../modules/reports-master-page/ReportsMasterPage'))
  const LabPaymentMasterPage = lazy(() => import('../modules/payment/LabPaymentMasterPage'))
  const WithdrawRequestMasterPage = lazy(
    () => import('../modules/withdraw-request/WithdrawRequestMasterPage')
  )
  
  const ExpenseHeaderMasterPage = lazy(
    () => import('../modules/expense-master-page/expense-header-page/ExpenseHeaderMasterPage')
  )

  const ExpenseTypeMasterPage = lazy(
    () => import('../modules/expense-master-page/expense-type-page/ExpenseTypeMasterPage')
  )
  const ExpenseMastersMasterPage = lazy(
    () => import('../modules/expense-master-page/expense-masters-page/ExpenseMastersMasterPage')
  )

  return (
    <Suspense fallback={<FallbackView />}>
      <Switch>
        <Route path='/dashboard' component={DashboardWrapper} />
        <Route path='/builder' component={BuilderPageWrapper} />
        <Route path='/crafted/pages/profile' component={ProfilePage} />
        <Route path='/crafted/pages/wizards' component={WizardsPage} />
        <Route path='/crafted/widgets' component={WidgetsPage} />
        <Route path='/crafted/account' component={AccountPage} />
        <Route path='/apps/chat' component={ChatPage} />
        <Route path='/menu-test' component={MenuTestPage} />
        <Route path='/master/country' component={CountryMasterPage} />
        <Route path='/master/taluka' component={TalukaMasterPage} />
        <Route path='/master/nationality' component={NationalityMasterPage} />
        <Route path='/master/eduDepartment' component={EducationDepartmentPage} />
        <Route path='/master/eduCategory' component={EducationCategoryPage} />
        <Route path='/master/documenttype' component={DocumentTypePage} />
        <Route path='/master/kycdocument' component={KycDocumentMasterPage} />
        <Route path='/master/unit' component={UnitMasterPage} />
        <Route path='/master/bannerimage' component={BannerImageMasterPage} />
        <Route path='/master/homevideo' component={HomeVideoMasterPage} />
        <Route path='/organization/employee' component={EmployeeMasterPage} />
        <Route path='/organization/user' component={UserMasterPage} />
        <Route path='/organization/customer' component={CustomerMasterPage} />
        <Route path='/organization/field-executive' component={FieldExecutiveMasterPage} />
        <Route path='/master/department' component={DepartmentMasterPage} />
        <Route path='/master/designation' component={DesignationMasterPage} />
        <Route path='/master/branch' component={BranchMasterPage} />
        <Route path='/master/bank' component={OrganizationBankMasterPage} />
        <Route path='/master/service-subcategory' component={ServiceSubCategoryMasterPage} />
        {/* ==================== Vehcile Manage ============== */}
        <Route path='/vehicle/type' component={VehicleTypeMasterPage} />
        <Route path='/vehicle/model' component={VehicleModelMasterPage} />
        <Route path='/vehicle/make' component={VehicleMakeMasterPage} />
        <Route path='/vehicle/vehicles' component={VehicleMasterPage} />
        {/* ==================== Service Manage ============== */}
        <Route path='/service-plan' component={ServicePlanMasterPage} />
        <Route path='/service-services' component={ServiceMasterPage} />
        <Route path='/service-type' component={ServiceTypeMasterPage} />
        <Route path='/service-schedule' component={ServiceScheduleMasterPage} />
        {/* ==================== Product Manage ============== */}
        <Route path='/product-manage/service-category' component={ServiceCategoryMasterPage} />
        <Route path='/product-manage/item-category' component={ItemCategoryMaterPage} />
        <Route path='/product-manage/items' component={ItemMaterPage} />
        <Route path='/product-manage/driver-tip' component={DriverTipMaterPage} />
        {/* --------------------- Purchase Manage ----------------------- */}
        <Route path='/purchase-management/vendor' component={VenderMasterPage} />
        <Route path='/purchase-management/purchase' component={PurchaseMasterPage} />
        <Route path='/purchase-management/inward' component={InventoryMasterPage} />
        <Route
          path='/purchase-management/without-po-inward'
          component={WithoutPOInventoryMasterPage}
        />
        <Route path='/purchase-management/current-stock' component={CurrentStockMasterPage} />
        <Route path='/purchase-management/purchase-invoice' component={PurchaseInvoiceMasterPage} />
        <Route
          path='/purchase-management/branch-to-branch-transfer'
          component={BranchToBranchTransferMasterPage}
        />
        {/* ==================== Locations ============== */}
        <Route path='/locations/state' component={StateMasterPage} />
        <Route path='/locations/city' component={CityMasterPageMasterPage} />
        <Route path='/locations/areapincode' component={AreaPinCodeMasterPage} />
        <Route path='/locations/society' component={SocietyMasterPage} />
        <Route path='/locations/pickup-drop-point' component={PickupDropPointMasterPage} />
        {/* //=============== Configuration ============= */}
        <Route path='/configuration' component={ConfigurationMasterPage} />
        {/* //=============== Configuration ============= */}
        {/* //=============== Configuration ============= */}
        <Route path='/offer' component={OfferMasterPage} />
        <Route path='/recharge-offer' component={RechargeOfferMasterPage} />
        <Route path='/wallet-recharge-history' component={WalletRechargeHistoryMasterPage} />
        {/* //=============== orders ============= */}
        <Route path='/order-service-orders' component={OpenOrderMasterPage} />
        <Route path='/order-service-feedback' component={FeedBackMasterPage} />
        <Route path='/orders/close-order' component={CloseOrderMasterPage} />
        <Route path='/orders/mismatch-order' component={MismatchOrderMasterPage} />
        <Route path='/orders/tip-manage' component={TipManageMasterPage} />
        <Route path='/expense/expense-head' component={ExpenseHeaderMasterPage} />
        <Route path='/expense/expense-type' component={ExpenseTypeMasterPage} />
        <Route path='/expense/expense-master' component={ExpenseMastersMasterPage} />
        {/* //=============== Reports ============= */}
        <Route path='/reports' component={ReportsMasterPage} />
        <Route path='/payment/cleaner-payment-report' component={LabPaymentMasterPage} />
        <Route path='/withdraw-request' component={WithdrawRequestMasterPage} />
        <Redirect from='/' to='/dashboard' />
        <Redirect exact from='/' to='/dashboard' />
        <Redirect to='error/404' />
      </Switch>
    </Suspense>
  )
}
